import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { TTeacherDirectory, TUpdateTeacherDirectory } from '@onesource/schemas';
import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';
import { getTeacherDirectoryQueryKey } from './use-get-teacher-directory-query';

export const useUpdateTeacherDirectoryMutation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TUpdateTeacherDirectory) => {
      const res = await axios.patch<TTeacherDirectory>(`/${TEACHER_DIRECTORY_PATH}`, payload);
      return res.data;
    },
    onSuccess: async data => {
      qc.setQueryData(getTeacherDirectoryQueryKey(), data);
      await qc.invalidateQueries({ queryKey: getTeacherDirectoryQueryKey() });

      enqueueSnackbar('Teacher profile updated successfully!', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
    onError: () => {
      enqueueSnackbar('Unable to update your teacher profile. Please try again.', {
        variant: 'error',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
  });
};
